"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const __elasticsearch_1 = require("../../../__elasticsearch");
const ElasticsearchEnums_1 = require("../../../__types/__enums/ElasticsearchEnums");
const getElasticsearchQueryFromFilters_1 = require("../../__common/elasticsearchQuery/getElasticsearchQueryFromFilters");
const parseElasticsearchResult_1 = require("../../__common/parseElasticsearchResult");
function getGroupsUsingScroll(scrollId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const elasticsearchClient = yield __elasticsearch_1.getElasticsearchClient(ElasticsearchEnums_1.ElasticsearchIndicesUrlMapping.group);
        const result = yield elasticsearchClient.scroll({ scrollId, scroll: '1m' });
        return parseElasticsearchResult_1.parseGroupsResult(result);
    });
}
exports.getGroupsUsingScroll = getGroupsUsingScroll;
function getGroupsUsingQuery(input, scroll) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const elasticsearchClient = yield __elasticsearch_1.getElasticsearchClient(ElasticsearchEnums_1.ElasticsearchIndicesUrlMapping.group);
        const { body, from = 0, _source, size = 100, sort } = input;
        const query = {
            index: ElasticsearchEnums_1.ElasticsearchIndicesEnum.GROUPS,
            type: ElasticsearchEnums_1.ElasticsearchTypesEnum.GROUP,
            scroll,
            body: Object.assign({}, body, { _source,
                from,
                size,
                sort })
        };
        const result = yield elasticsearchClient.search(query);
        return parseElasticsearchResult_1.parseGroupsResult(result);
    });
}
exports.getGroupsUsingQuery = getGroupsUsingQuery;
function loadGroupsFromGroupIds(filters, _source = {}) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const queryObj = getElasticsearchQueryFromFilters_1.getElasticsearchQueryForFilters(filters);
        if (Object.keys(queryObj.bool).length > 0) {
            const query = { size: 100, _source, body: { query: queryObj } };
            // Fetching the first batch of groups using query and getting scrollId
            const elasticsearchResult = yield getGroupsUsingQuery(query, '30s');
            const { scrollId, groups, total } = elasticsearchResult;
            // Fetching remaing batch of groups using scroll
            return fetchFromScroll({
                total,
                groups,
                scrollId
            });
        }
        return [];
    });
}
exports.loadGroupsFromGroupIds = loadGroupsFromGroupIds;
function fetchFromScroll(input) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const total = input.total;
        const groups = input.groups;
        let remainingDocs = total - groups.length;
        if (input.scrollId && remainingDocs > 0) {
            let currentElasticsearchResult;
            do {
                currentElasticsearchResult = yield getGroupsUsingScroll(input.scrollId);
                remainingDocs -= currentElasticsearchResult.groups.length;
                groups.push(...currentElasticsearchResult.groups);
            } while (remainingDocs > 0);
        }
        return groups;
    });
}
exports.fetchFromScroll = fetchFromScroll;
//# sourceMappingURL=groupQueryHelper.js.map